import { performRequestSecond, performRequestThird, performRequestFourth } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import { getTenantDetails } from 'utils/utils';

export const generateCaseReport = (queryParams = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.generateReport}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.PATCH, url, {});
};

export const generateReport = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.reports}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data);
};

export const openCaseListRds = (data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.openCaseListRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestFourth(apiEndPoints.methodType.POST, url, data);
};

export const openCaseCardRds = (data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.openCaseCardRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestFourth(apiEndPoints.methodType.POST, url, data);
};

export const medicalProviderReport = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.medicalProvider}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data);
};

export const vendorReport = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.vendorReport}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data);
};
export const firmUserCaseReport = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.generateFirmUserCaseReport}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data);
};

export const exportReport = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.exportReports}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data);
};

export const exportFrrReport = (queryParams = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.exportFrrReports}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestThird(apiEndPoints.methodType.GET, url);
};

export const getFuturePaymentMonthData = (data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getFutureMonths}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${
    data?.timezone_offset ? `&timezone_offset=${data?.timezone_offset}` : ''
  }`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data);
};

export const getCaseList = (queryParams, data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getCaseList}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams || ''}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data);
};

export const getGlanceTotals = (timezone_offset, data, excludeFromLoading = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getGlanceTotals}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&timezone_offset=${timezone_offset || ''}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data, '', true, excludeFromLoading);
};

export const getNpsReport = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getNpsReport}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;

  return performRequestThird(apiEndPoints.methodType.PUT, url, data);
};

export const firmUserCaseReportRDS = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.firmUserCaseReportRDS}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

// New API: Firm User Case Report Card - Aggregate totals
export const firmUserCaseReportCard = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.firmUserCaseReportCard}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

// New API: Firm User Case Report List - Detailed data with pagination
export const firmUserCaseReportList = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.firmUserCaseReportList}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const userGroupReportRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.userGroupReportRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

// Firm User Group Report APIs - for async calls
export const firmUserGroupReportList = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.firmUserGroupReportList}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const firmUserGroupReportSummary = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.firmUserGroupReportSummary}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const pastDueReportRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.pastDueReportRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const pastDueReportCardRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.pastDueReportCardRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const trustAccountTransactionReportRds = async (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.trustAccountTransactionsReport}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return await performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const trustAccountTransactionTotals = async (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.trustAccountTransactionTotals}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return await performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

// New Trust Balance Report APIs
export const trustBalanceReportCardRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.trustBalanceReportCardRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const trustBalanceReportListingRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.trustBalanceReportListingRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const paymentReportRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.paymentReportRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

// New Payment Report APIs as per documentation
export const paymentReportCardRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.paymentReportCardRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const paymentReportListingRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.paymentReportListingRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const futureRevenueReportRds = (queryParams = '', data = {}) => {
  // Use new API format without tenant_sk
  let url = `${apiEndPoints.futureRevenueReportRds}?${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

// Revenue Report APIs
export const revenueViewReportCard = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.revenueViewReportCard}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const revenueViewReportList = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.revenueViewReportList}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const invoiceReportRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.invoiceReportRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

// New Invoice Report APIs - Split into list and totals for async calls
export const invoiceReportList = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.invoiceReportList}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const invoiceReportTotalsRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.invoiceReportTotalsRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

// New Vendor Report APIs
export const vendorReportListRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.vendorReportListRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const vendorReportCardRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.vendorReportCardRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

// New Medical Provider Report APIs
export const medicalProviderReportListRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.medicalProviderReportListRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const medicalProviderReportCardRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.medicalProviderReportCardRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

// Personal Injury Case Expense Report APIs
export const CaseExpenseReportListRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.CaseExpenseReportListRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const CaseExpenseReportCardRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.CaseExpenseReportCardRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

// Personal Injury Medical Expense Report APIs
export const medicalExpenseReportListRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.medicalExpenseReportListRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

// Personal Injury Settlement Report RDS APIs
export const piSettlementReportListRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.piSettlementReportListRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const piSettlementReportCardRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.piSettlementReportCardRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const medicalExpenseReportCardRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.medicalExpenseReportCardRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const leadReportRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.leadReportRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const referralReportRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.referralReportRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const leadSourceReportRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.leadSourceReportRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

// Conversion Report APIs
export const conversionReportRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.conversionReportRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const conversionReportCardRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.conversionReportCardRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const inboundReferralReportRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.inboundReferralReportRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const outboundReferralReportRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.outboundReferralReportRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const leadReportList = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.leadReportList}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const leadReportCard = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.leadReportCard}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

// /** Case and Lead Resolution Report — RDS list */
// export const leadResolutionReportList = (queryParams = '', data = {}) => {
//   const [tenantId, tenantSk] = getTenantDetails();
//   let url = `${apiEndPoints.leadResolutionReportList}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
//   return performRequestFourth(apiEndPoints.methodType.POST, url, data);
// };

// /** Case and Lead Resolution Report — RDS aggregate card */
// export const leadResolutionReportCard = (queryParams = '', data = {}) => {
//   const [tenantId, tenantSk] = getTenantDetails();
//   let url = `${apiEndPoints.leadResolutionReportCard}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
//   return performRequestFourth(apiEndPoints.methodType.POST, url, data);
// };

/** Case Stage and Age Report — RDS list */
export const caseStageAgeReportList = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.caseStageAgeReportList}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestFourth(apiEndPoints.methodType.POST, url, data);
};

/** Case Stage and Age Report — RDS aggregate card */
export const caseStageAgeReportCard = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.caseStageAgeReportCard}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestFourth(apiEndPoints.methodType.POST, url, data);
};

// SOL Report RDS
export const solReportRds = (queryParams = '', data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.solReportRds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${queryParams}`;
  return performRequestFourth(apiEndPoints.methodType.POST, url, data);
};
